import { RefObject } from 'react';
import { useCoverageBridge } from './useCoverageBridge';
import { useProgrammingBridge } from './useProgrammingBridge';

interface UseAnalysisBridgesArgs {
  slug: string;
  analysisId: string;
  token: string | null;
  iframeRef: RefObject<HTMLIFrameElement>;
  channelIdRef: RefObject<string>;
  targetOriginRef: RefObject<string | null>;
}

/** Agrupa los puentes postMessage del iframe (Programación + Cobertura) — un único punto de wiring en AnalysisViewerPage. */
export function useAnalysisBridges(args: UseAnalysisBridgesArgs): void {
  useProgrammingBridge(args);
  useCoverageBridge(args);
}
